import { useApolloClient } from '@apollo/client'
import { InFilterDefinition } from '@factorialco/f0-react'
import { EmployeeTeamsFilterDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const sortByLabel = (left: { label: string }, right: { label: string }) =>
  left.label.localeCompare(right.label)

export const useTeamFilter = (): InFilterDefinition<string> => {
  const client = useApolloClient()

  return {
    label: i18n.t('employees.employees_list.filters.team'),
    type: 'in' as const,
    options: {
      cache: true,
      options: async () => {
        const { data } = await client.query({
          query: EmployeeTeamsFilterDocument,
          fetchPolicy: 'cache-first',
        })

        return data.teams.teams
          .map((team) => ({
            label: team.name,
            value: team.id,
          }))
          .sort(sortByLabel)
      },
    },
  }
}
